import { Component, OnInit } from '@angular/core';
import { AgCharts } from "ag-charts-angular";
import {
  AgBarSeriesOptions,
  AgChartOptions,
  BarSeriesModule,
  LineSeriesModule,
  CategoryAxisModule,
  LegendModule,
  ModuleRegistry,
  NumberAxisModule,
} from "ag-charts-community";
import { MapService } from '../map.service';

ModuleRegistry.registerModules([
  BarSeriesModule,
  LineSeriesModule,
  LegendModule,
  CategoryAxisModule,
  NumberAxisModule,
]);

@Component({
  standalone: true,
  selector: 'app-featureinfochart',
  templateUrl: './featureinfochart.component.html',
  styleUrls: ['./featureinfochart.component.css'],
  imports: [AgCharts]
})
export class FeatureinfochartComponent implements OnInit {

  constructor(public mapService:MapService) {
  }

  ngOnInit(): void {
  }

}
